export const banners = [
  { id: 1, img: 'https://picsum.photos/1200/450?random=101', link: '', alt: '示例轮播 1' },
  { id: 2, img: 'https://picsum.photos/1200/450?random=102', link: '', alt: '示例轮播 2' }
]

export const services = [
  { id: 1, name: '示例服务 A', cover: 'https://picsum.photos/360/220?random=201', summary: '这是占位服务介绍，请在后台替换为正式内容。' },
  { id: 2, name: '示例服务 B', cover: 'https://picsum.photos/360/220?random=202', summary: '这是占位服务介绍，请在后台替换为正式内容。' },
  { id: 3, name: '示例服务 C', cover: 'https://picsum.photos/360/220?random=203', summary: '这是占位服务介绍，请在后台替换为正式内容。' }
]

export const partners = [
  { id: 1, logo: 'https://picsum.photos/180/80?random=301', name: '合作方示例', link: '' },
  { id: 2, logo: 'https://picsum.photos/180/80?random=302', name: '合作方示例', link: '' }
]

export const newsList = [
  {
    id: 1,
    title: '示例资讯标题（请在后台修改）',
    cover: 'https://picsum.photos/420/240?random=401',
    date: '2026-01-01',
    author: '编辑部',
    summary: '这是占位摘要，可在管理后台发布真实图文资讯。',
    content: '<p>这是占位正文。</p><p>可在后台使用图文编辑器替换为正式内容。</p>'
  }
]
